import React, { Component } from 'react';
import DownloadableForms from '../../containers/DownloadableForms/DownloadableForms';

class DownloadableFormsPage extends Component {
  render() {
    return <DownloadableForms />;
  }
}

export default DownloadableFormsPage;
